import axiosInstance from '../../../config/axiosInstance';
const LeadService = {
    async GetAllLeads(redirectCallback, Start, PageSize, searchQuery, sortColumn, sortDirection, EmailingName = "", SearchColumns, AssignTo) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Lead/GetAllLeads?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllLeadForQuotations(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Lead/GetAllLeadForQuotations?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetLeadCount(redirectCallback, searchQuery, EmailingName = "", SearchColumns, AssignTo) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Lead/GetLeadCount?ClientID=${ClientID}&searchQuery=${searchQuery}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&AssignTo=${AssignTo}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetLeadByID(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Lead/GetLeadByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteLead(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Lead/DeleteLead?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async LockLead(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Lead/LockLead?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockLead(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Lead/UnLockLead?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetAllLeadAppointments(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Lead/GetAllLeadAppointments?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetLeadsForExport(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Lead/GetLeadsForExport?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async AssignLeadToUser(multipleIds, UserID, Module) {
        try {

            const response = await axiosInstance.get(`/Lead/AssignLeadToUser?multipleIds=${multipleIds}&UserID=${UserID}&Module=${Module}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnAssignLeadToUser(multipleIds, Module) {
        try {

            const response = await axiosInstance.get(`/Lead/UnAssignLeadToUser?multipleIds=${multipleIds}&Module=${Module}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async inbox({ folder = "Inbox", nextLink = null, page = 1, limit = 20 }) {
        try {
            const ClientID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");
            const Email = localStorage.getItem("Email");

            let url = `/Lead/inbox?ClientID=${ClientID}&UserID=${UserID}&Email=${Email}&folder=${encodeURIComponent(folder)}`;

            if (nextLink) {
                // Only send nextLink, do NOT send page or limit
                url += `&nextLink=${encodeURIComponent(nextLink)}`;
            } else {
                url += `&page=${page}&limit=${limit}`;
            }

            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            console.error("Inbox service error:", error);
            throw error;
        }
    },

    async saveselected(selectedEmails) {
        try {

            const response = await axiosInstance.post(`/Lead/save-selected`, { selectedEmails });
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async CreateCommuncationInbox(CommunicationHistory, LeadID, Module) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');

            const payload = {
                ClientID,
                UserID,
                LeadID,
                CommunicationHistory, // <-- selectedEmails array
                Module
            };

            const response = await axiosInstance.post(
                `/Lead/CreateCommuncationInbox`,
                payload
            );

            return response.data;
        } catch (error) {
            console.error('Error saving inbox:', error);
            throw error;
        }
    },
    async SyncInboxEmail() {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Lead/SyncInboxEmail?ClientID=${ClientID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async getMailFolders() {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const Email = localStorage.getItem("Email");

            const response = await axiosInstance.get(`/Lead/getMailFolders?ClientID=${ClientID}&UserID=${UserID}&Email=${Email}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching mail folders:', error);
            throw error;
        }
    },



};

export default LeadService;